import { createSelector } from 'reselect'

import { getUser } from 'common'
import { isAvailableFeatureSelector } from 'features/billing'

const objectLevelPermissionsSelector = (state) => state.objectLevelPermissions

export const isOpenSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ isOpen }) => isOpen
)

export const eventTypeSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ eventType }) => eventType
)

export const eventTypeMembershipsUserIdsSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ eventType }) => eventType.memberships.map((membership) => membership.user_id).filter(Boolean)
)

export const eventTypeMembershipsOrgInviteIdsSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ eventType }) => eventType.memberships.map((membership) => membership.organization_invitation_id).filter(Boolean)
)

export const isNewEventTypeSelector = createSelector(
  objectLevelPermissionsSelector,
  (eventType) => !eventType?.id
)

export const eventTypeParticipantsSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ eventTypeParticipants }) => eventTypeParticipants
)

export const isHostSelectedSelector = createSelector(
  eventTypeParticipantsSelector,
  (participants) => participants.some(
    ({ principleType, isHost }) => principleType === 'User' && isHost
  )
)

export const isSubmittingSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ isSubmitting }) => isSubmitting
)

export const isTouchedSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ isTouched }) => isTouched
)

export const isPersonalEventTypeSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.owner_type === 'User'
)

export const canEditWithoutOLPSelector = createSelector(
  eventTypeSelector,
  ({ policy }) => policy.edit_without_olp
)

export const newOwnerSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ newOwner }) => newOwner
)

export const isEventTypeOwnerSelector = (userUUID) => createSelector(
  objectLevelPermissionsSelector,
  ({ eventType }) => userUUID === eventType.owner_uuid
)

export const isCurrentUserSelector = (userUUID) => createSelector(
  getUser.select(),
  ({ data: { uuid } }) => uuid === userUUID
)

export const isCurrentUserEventTypeOwnerSelector = createSelector(
  getUser.select(),
  objectLevelPermissionsSelector,
  ({ data: { uuid } }, { eventType }) => uuid === eventType.owner_uuid
)

const initialParticipantsSelector = createSelector(
  objectLevelPermissionsSelector,
  ({ initialParticipants }) => initialParticipants
)

export const membershipPickerInitialValueSelector = createSelector(
  initialParticipantsSelector,
  isPersonalEventTypeSelector,
  ({ organizationMembershipIds, organizationInvitationIds, organizationMigrationIds }, isPersonal) => (isPersonal
    ? { organizationMembershipIds }
    : { organizationMembershipIds, organizationInvitationIds, organizationMigrationIds })
)

export const isAvailableSelector = (state) => isAvailableFeatureSelector(state, {
  featureKey: 'object_level_permissions'
})
